module.exports = __webpack_public_path__ + "img/Frame 752.1b07c10a.png";